import { IUsersGetResponse, Route } from "@edgetier/watchtower-types";
import { trimOrNull } from "@edgetier/utilities";
import { useState } from "react";
import { useQuery } from "react-query";
import { axios } from "utilities/axios";

/**
 * Request users from the backend.
 * @returns A paginated users object.
 */
const requestUsers = async (page: string | null, search: string | null) => {
    const url = page === null ? Route.Users : page;
    const { data } = await axios.get<IUsersGetResponse>(url, { params: { search } });
    return data;
};

/**
 * A query for requesting the users with pagination.
 */
export const useUsers = () => {
    const [page, setPage] = useState<string | null>(null);
    const [search, setSearch] = useState<string | null>(null);
    const result = useQuery([Route.Users, page, search], () => requestUsers(page, search));
    return {
        ...result,
        fetchNextPage: () => {
            const nextPage = result.data?.pagination.nextPage;
            if (typeof nextPage === "string") {
                setPage(nextPage);
            }
        },
        fetchPreviousPage: () => {
            const previousPage = result.data?.pagination.previousPage;
            if (typeof previousPage === "string") {
                setPage(previousPage);
            }
        },
        hasNextPage: typeof result.data?.pagination.nextPage === "string",
        hasPreviousPage: typeof result.data?.pagination.previousPage === "string",
        search: (search: string) => {
            setSearch(trimOrNull(search));
        },
        resetPage: () => {
            setPage(null);
        },
    };
};
